<script setup>
import Text from "@/v2/primitives/Text/Text.vue";
import Icon from "@/v2/primitives/Icon/Icon.vue";
import QrcodeVue from "qrcode.vue";
import { computed } from "vue";

const props = defineProps({
  hasInstructions: {
    type: Boolean,
    default: false,
  },
  hasIcon: {
    type: Boolean,
    default: false,
  },
  url: {
    type: String,
    default: "",
  },
  size: {
    type: Number,
    default: 150,
  },
});

const qrColor = computed(() => "var(--qrcode-color)");

const qrBackgroundColor = computed(() => "var(--qrcode-background)");

const hasPadding = computed(() => props.hasInstructions || props.hasIcon);
</script>

<template>
  <div class="qr-code" :class="{ 'qr-code--has-padding': hasPadding }">
    <Icon v-if="hasIcon" name="camera" class="qr-code__icon" />

    <Text v-if="hasInstructions" variant="body" class="qr-code__instructions"
      >Scan with your Camera App to view on your phone.</Text
    >
    <div class="qr-code__wrapper">
      <QrcodeVue
        :value="url"
        render-as="svg"
        :size="size"
        :foreground="qrColor"
        :background="qrBackgroundColor"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.qr-code {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-base);
  align-self: stretch;

  &--has-padding {
    padding: var(--spacing-base-lg) var(--spacing-base);
  }

  &__icon {
    color: var(--button-primary-raised-text);
    font-size: 40px;
  }

  &__instructions {
    text-align: center;
    color: var(--colors-primary-neutral);
  }

  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--spacing-base-sm);
    border-radius: var(--spacing-base-sm);
    box-shadow: var(--shadow-raised);
    background-color: var(--qrcode-background);
  }
}
</style>
